import React, { useEffect } from 'react';
import { useOutageLeftPanelState } from '../../providers/OutageLeftPanelStateProvider';

export function ResetCRCLeftPanel() {
  const {
    setOutageMarkerView,
    setSelectedOutageInfo,
    setSinglePremiseInfo,
    setMultiPremiseInfo,
  } = useOutageLeftPanelState();

  useEffect(() => {
    void 0;
    return () => {
      setOutageMarkerView(undefined);
      setSelectedOutageInfo(undefined);
      setSinglePremiseInfo(undefined);
      setMultiPremiseInfo(undefined);
    };
  }, []);

  return <></>;
}
